import { z } from 'zod';

const common = z.object({
  attributes: z.record(z.string(), z.string()),
  slug: z
    .string()
    .regex(/^[a-z0-9-]*$/iu, 'Contains illegal characters')
    .transform((val) => val.toString().toLowerCase())
    .optional(),
  title: z.string().trim().min(1, 'title is required'),
});

export const createSchema = z
  .object({
    modelId: z.string(),
  })
  .extend(common.shape);

export const updateSchema = common;
